//import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './library/foundation'

$( document ).foundation();

import { library, dom, config } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons'

config.searchPseudoElements = true
config.autoAddCss= true

// Add all icons to the library so you can use it in your page
library.add(fas, far, fab, faAngleLeft)

dom.watch()
